import React, { useEffect } from "react";
import { createPortal } from "react-dom";
import { X } from "lucide-react";

// Chrome di modale condivisa fra Guida e Videoguida: stesso linguaggio
// visivo dei dialoghi già presenti nell'app (vedi ConfirmDeleteDialog in
// ui-kit.jsx), per restare coerenti col resto della piattaforma.
export default function AcademyModal({ open, onClose, icon, title, subtitle, children, maxWidthCls = "max-w-lg" }) {
  useEffect(() => {
    if (!open) return undefined;
    const close = (event) => { if (event.key === "Escape") onClose?.(); };
    document.addEventListener("keydown", close);
    return () => document.removeEventListener("keydown", close);
  }, [open, onClose]);
  if (!open) return null;
  return createPortal(
    <div className="fixed inset-0 z-[100] flex items-end justify-center bg-navy/60 p-0 backdrop-blur-sm sm:items-center sm:p-4" role="presentation" onMouseDown={(event) => { if (event.target === event.currentTarget) onClose?.(); }}>
      <div role="dialog" aria-modal="true" className={`relative max-h-[92dvh] w-full ${maxWidthCls} overflow-y-auto rounded-t-2xl bg-white p-6 shadow-2xl sm:rounded-2xl sm:p-7`}>
        <button type="button" onClick={onClose} className="absolute right-3 top-3 grid h-11 w-11 place-items-center rounded-full text-slate-500 hover:bg-slate-100" aria-label="Chiudi"><X className="h-5 w-5" /></button>
        <div className="flex items-start gap-3 pr-10">
          {icon && <div className="grid h-11 w-11 shrink-0 place-items-center rounded-xl bg-gold/15 text-navy">{icon}</div>}
          <div className="min-w-0">
            <h2 className="font-heading text-xl font-bold text-navy">{title}</h2>
            {subtitle && <p className="mt-0.5 text-sm text-slate-500">{subtitle}</p>}
          </div>
        </div>
        <div className="mt-5">{children}</div>
      </div>
    </div>,
    document.body,
  );
}
